// subscription-card-transform.js
(function() {
  'use strict';
  
  // Wait for DOM to be ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initSubscriptionCards);
  } else {
    initSubscriptionCards();
  }
  
  function initSubscriptionCards() {
    // Find the Appstle widget
    const appstleWidget = document.querySelector('.appstle_sub_widget.WIDGET_TYPE_7');
    if (!appstleWidget) return;
    
    // Hide the original Appstle options but keep the functionality
    appstleWidget.style.opacity = '0';
    appstleWidget.style.position = 'absolute';
    appstleWidget.style.pointerEvents = 'none';
    appstleWidget.style.height = '0';
    appstleWidget.style.overflow = 'hidden';
    
    // Get the hidden inputs we need
    const variantInput = document.querySelector('input[name="id"]');
    const sellingPlanInput = document.querySelector('input[name="selling_plan"]');
    const addToCartForm = document.querySelector('form.wt-product__add-to-cart_form');
    
    // Get variant data
    const oneTimeVariantId = '53064508637498'; // Begin with Just the Seat
    const subscriptionVariantId = '53064508670266'; // Enter the Ritual Continuum
    const sellingPlanId = '693340864826';
    
    // Create our custom cards container
    const customContainer = document.createElement('div');
    customContainer.className = 'custom-subscription-cards';
    customContainer.innerHTML = `
      <div class="choose-path">
        <span class="section-title">Choose Your Path:</span>
        
        <div class="card-holder">
          <!-- Subscription Card (Enter the Ritual Continuum) -->
          <label class="path-card subscription-card" data-variant-id="${subscriptionVariantId}" data-selling-plan="${sellingPlanId}">
            <input type="radio" name="custom_variation" class="radio-btn" value="${subscriptionVariantId}" data-selling-plan="${sellingPlanId}">
            <div class="card-content">
              <span class="custom-radio"></span>
              <h2>
                <span class="woocommerce-product-sub-heading">Enter the Ritual Continuum</span>
                <span class="tooltip-wrapper">
                  <img src="{{ 'info-icon.png' | asset_url }}" alt="info" width="18" height="18">
                  <span class="tooltip-text">
                    <img src="{{ 'tooltip-image.jpg' | asset_url }}" alt="Ritual Continuum Info" class="img" width="200">
                  </span>
                </span>
              </h2>
              <p class="price">
                <span class="price-first-part">
                  <span class="woocommerce-Price-amount amount">
                    <bdi>$299.00</bdi>
                  </span> today
                </span>
                <span class="price-second-part normal">
                  + <span class="price-month-amount">
                    <span class="woocommerce-Price-amount amount">
                      <bdi>$29.95</bdi>
                    </span>/month
                  </span>
                </span>
              </p>
              <p class="desc">A relaxed anchoring into womb rhythm, with monthly support.</p>
              <ul class="product-variation-subscription-list">
                <li>LEIAMOON Steam Seat with Facial Attachment</li>
                <li>1 Herb Blend per Month of Your Choosing</li>
                <li>Access to the Audio Meditation Library</li>
                <li>Seasonal Virtual Circle Invites</li>
                <li>Private Sisterhood Space</li>
              </ul>
              <p class="note">Continue monthly. Cancel anytime. Return when ready.</p>
            </div>
          </label>
          
          <!-- One-time Card (Begin with Just the Seat) -->
          <label class="path-card one-time-card" data-variant-id="${oneTimeVariantId}">
            <input type="radio" name="custom_variation" class="radio-btn" value="${oneTimeVariantId}" data-selling-plan="">
            <div class="card-content">
              <span class="custom-radio"></span>
              <h2>
                <span class="woocommerce-product-sub-heading">Begin with Just the Seat</span>
                <span class="tooltip-wrapper">
                  <img src="{{ 'info-icon.png' | asset_url }}" alt="info" width="18" height="18">
                  <span class="tooltip-text">
                    <img src="{{ 'tooltip-image-2.jpg' | asset_url }}" alt="Just the Seat Info" class="img" width="200">
                  </span>
                </span>
              </h2>
              <p class="price">
                <strong>
                  <span class="woocommerce-Price-amount amount">
                    <bdi>$349.00</bdi>
                  </span>
                </strong>
              </p>
              <p class="italic">Start your practice with the tool alone, at your own rhythm.</p>
              <ul class="product-variation-subscription-list">
                <li>LEIAMOON Steam Seat and accessories</li>
                <li>Illustrated Guide</li>
              </ul>
            </div>
          </label>
        </div>
        
        <div class="shipping-info">
          <div class="icon-wrapper">
            <img src="{{ 'truck-icon.png' | asset_url }}" alt="Truck Icon" width="30" height="30">
          </div>
          <p>
            <strong>Your order ships free, with care and intention.</strong><br>
            Once your seat is prepared, you’ll receive tracking info. We ship from the USA within 2 business days
          </p>
        </div>
      </div>
    `;
    
    // Insert our custom cards before the add to cart button
    const addToCartWrapper = document.querySelector('.wt-product__add-to-cart_form--wrapper');
    if (addToCartWrapper) {
      addToCartWrapper.insertBefore(customContainer, addToCartWrapper.querySelector('button'));
    }
    
    // Hide quantity counter
    const quantityCounter = document.querySelector('.counter-wrapper');
    if (quantityCounter) {
      quantityCounter.style.display = 'none';
    }
    
    // Add CSS styles
    addStyles();
    
    // Set up event listeners
    setupEventListeners(customContainer, variantInput, sellingPlanInput, addToCartForm);
    
    // Set default selection (subscription card)
    setTimeout(() => {
      const subscriptionCard = customContainer.querySelector('.subscription-card input');
      if (subscriptionCard) {
        subscriptionCard.checked = true;
        subscriptionCard.dispatchEvent(new Event('change'));
      }
    }, 100);
  }
  
  function setupEventListeners(container, variantInput, sellingPlanInput, form) {
    // Handle radio button changes
    const radios = container.querySelectorAll('input[name="custom_variation"]');
    
    radios.forEach(radio => {
      radio.addEventListener('change', function() {
        // Update selected state
        container.querySelectorAll('.path-card').forEach(card => {
          card.classList.remove('selected');
        });
        this.closest('.path-card').classList.add('selected');
        
        // Update hidden inputs
        if (variantInput) {
          variantInput.value = this.value;
        }
        
        if (sellingPlanInput) {
          if (this.dataset.sellingPlan) {
            sellingPlanInput.value = this.dataset.sellingPlan;
            
            // Also trigger the Appstle radio to keep it in sync
            const appstleRadio = document.querySelector(`input[name="selling_plan"][value="${this.dataset.sellingPlan}"]`);
            if (appstleRadio) {
              appstleRadio.checked = true;
              appstleRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          } else {
            sellingPlanInput.value = '';
            
            // Select the one-time option in Appstle
            const oneTimeRadio = document.querySelector('input[name="selling_plan"][value=""]');
            if (oneTimeRadio) {
              oneTimeRadio.checked = true;
              oneTimeRadio.dispatchEvent(new Event('change', { bubbles: true }));
            }
          }
        }
      });
    });
    
    // Intercept form submission to ensure correct data
    if (form) {
      const originalSubmit = form.onsubmit;
      form.addEventListener('submit', function(e) {
        const selectedRadio = container.querySelector('input[name="custom_variation"]:checked');
        if (!selectedRadio) {
          e.preventDefault();
          alert('Please select an option');
          return false;
        }
        
        // Ensure hidden inputs are correct
        if (variantInput) {
          variantInput.value = selectedRadio.value;
        }
        
        if (sellingPlanInput) {
          sellingPlanInput.value = selectedRadio.dataset.sellingPlan || '';
        }
        
        return true;
      });
    }
  }
  
  function addStyles() {
    const style = document.createElement('style');
    style.textContent = `
      /* Hide quantity counter */
      .counter-wrapper {
        display: none !important;
      }
      
      /* Custom cards styling */
      .custom-subscription-cards {
        width: 100%;
        margin: 20px 0;
      }
      
      .custom-subscription-cards .choose-path {
        max-width: 1200px;
        margin: 0 auto;
      }
      
      .custom-subscription-cards .section-title {
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 20px;
        display: block;
        color: #333;
      }
      
      .custom-subscription-cards .card-holder {
        display: flex;
        gap: 30px;
        margin-bottom: 30px;
        flex-wrap: wrap;
      }
      
      .custom-subscription-cards .path-card {
        flex: 1;
        min-width: 300px;
        cursor: pointer;
        border: 2px solid #e0e0e0;
        border-radius: 12px;
        transition: all 0.3s ease;
        background: white;
        position: relative;
      }
      
      .custom-subscription-cards .path-card:hover {
        border-color: #c4a484;
        transform: translateY(-5px);
        box-shadow: 0 10px 25px rgba(0,0,0,0.1);
      }
      
      .custom-subscription-cards .path-card.selected {
        border-color: #c4a484;
        background: #fef9f4;
        box-shadow: 0 10px 25px rgba(196, 164, 132, 0.15);
      }
      
      .custom-subscription-cards .path-card input[type="radio"] {
        display: none;
      }
      
      .custom-subscription-cards .card-content {
        padding: 25px;
        position: relative;
      }
      
      .custom-subscription-cards .custom-radio {
        position: absolute;
        top: 20px;
        right: 20px;
        width: 20px;
        height: 20px;
        border: 2px solid #c4a484;
        border-radius: 50%;
      }
      
      .custom-subscription-cards input:checked + .card-content .custom-radio {
        background: #c4a484;
        box-shadow: inset 0 0 0 5px white;
      }
      
      .custom-subscription-cards .path-card h2 {
        margin-top: 0;
        margin-bottom: 15px;
        font-size: 20px;
        color: #333;
        display: flex;
        align-items: center;
        gap: 8px;
        flex-wrap: wrap;
        padding-right: 30px;
      }
      
      .custom-subscription-cards .woocommerce-product-sub-heading {
        font-weight: 600;
      }
      
      .custom-subscription-cards .tooltip-wrapper {
        position: relative;
        display: inline-block;
        cursor: help;
      }
      
      .custom-subscription-cards .tooltip-wrapper img {
        width: 18px;
        height: 18px;
        vertical-align: middle;
      }
      
      .custom-subscription-cards .tooltip-text {
        visibility: hidden;
        position: absolute;
        z-index: 10;
        bottom: 125%;
        left: 50%;
        transform: translateX(-50%);
        background: white;
        border-radius: 8px;
        padding: 10px;
        box-shadow: 0 5px 20px rgba(0,0,0,0.15);
        white-space: nowrap;
        opacity: 0;
        transition: opacity 0.3s;
      }
      
      .custom-subscription-cards .tooltip-text img {
        width: 200px;
        height: auto;
        max-width: 200px;
      }
      
      .custom-subscription-cards .tooltip-wrapper:hover .tooltip-text {
        visibility: visible;
        opacity: 1;
      }
      
      .custom-subscription-cards .price {
        font-size: 18px;
        margin-bottom: 15px;
        color: #c4a484;
        font-weight: 500;
      }
      
      .custom-subscription-cards .price-first-part {
        display: inline-block;
        margin-right: 5px;
      }
      
      .custom-subscription-cards .price-second-part {
        display: inline-block;
        color: #666;
        font-size: 16px;
      }
      
      .custom-subscription-cards .desc,
      .custom-subscription-cards .italic {
        font-style: italic;
        color: #666;
        margin-bottom: 15px;
        line-height: 1.5;
      }
      
      .custom-subscription-cards .product-variation-subscription-list {
        list-style: none;
        padding: 0;
        margin: 0 0 15px 0;
      }
      
      .custom-subscription-cards .product-variation-subscription-list li {
        padding: 8px 0 8px 25px;
        position: relative;
        color: #555;
        font-size: 14px;
        line-height: 1.4;
      }
      
      .custom-subscription-cards .product-variation-subscription-list li:before {
        content: "✓";
        position: absolute;
        left: 0;
        color: #c4a484;
        font-weight: bold;
      }
      
      .custom-subscription-cards .note {
        font-size: 13px;
        color: #888;
        font-style: italic;
        margin-top: 15px;
        padding-top: 15px;
        border-top: 1px solid #e0e0e0;
      }
      
      .custom-subscription-cards .shipping-info {
        display: flex;
        align-items: center;
        gap: 15px;
        background: #f8f8f8;
        padding: 20px;
        border-radius: 8px;
        margin-bottom: 30px;
      }
      
      .custom-subscription-cards .icon-wrapper {
        flex-shrink: 0;
      }
      
      .custom-subscription-cards .icon-wrapper img {
        width: 30px;
        height: 30px;
      }
      
      .custom-subscription-cards .shipping-info p {
        margin: 0;
        color: #333;
        font-size: 14px;
        line-height: 1.6;
      }
      
      .custom-subscription-cards .shipping-info strong {
        color: #c4a484;
      }
      
      @media (max-width: 768px) {
        .custom-subscription-cards .card-holder {
          flex-direction: column;
          gap: 20px;
        }
        
        .custom-subscription-cards .path-card {
          min-width: 100%;
        }
        
        .custom-subscription-cards .section-title {
          font-size: 20px;
        }
        
        .custom-subscription-cards .shipping-info {
          flex-direction: column;
          text-align: center;
        }
      }
    `;
    
    document.head.appendChild(style);
  }
})();